<template>
  <!-- 开票信息管理 -->
  <div class="page">
    <div class="one">
      <div class="title">发票信息管理</div>
      <el-divider></el-divider>
      <div class="yi">
        <div class="left">
          <div class="text">
            <p>发票信息管理</p>
            <p>填写前请务必注意以下问题:</p>
            <p>1.申请发票前请完善开票信息</p>
            <p>
              2.请在提交开票申请前仔细核实开票信息，发票开具后无法作废、修改
            </p>
            <p>3.有问题请扫描右方二维码咨询在线客服或致电客服:400-003-1733</p>
          </div>
          <div class="image">
            <img src="../assets/login/code.png" alt="" />
          </div>
        </div>
        <div class="right">
          <el-form ref="formHead" :model="comInfo" label-position="right">
            <el-row>
              <el-col :span="24">
                <el-form-item label="企业名称：" style="margin-bottom: 0">
                  <el-input v-model="comInfo.companyName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="统一社会信用代码："
                  style="margin-bottom: 0"
                >
                  <el-input
                    v-model="comInfo.companyLawCode"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </div>
    <el-form ref="form" :model="form" label-width="140px" :rules="rules">
      <div class="one">
        <div class="title">经办人信息</div>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="开户行名称：" prop="bankName">
              <el-input v-model="form.bankName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="固定电话：" prop="invoicePhone">
              <el-input v-model="form.invoicePhone"></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="注册地址：">
              <el-input
                v-model="comInfo.companyAddress"
                disabled
              ></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="开户行基本账号：" prop="bankCode">
              <el-input v-model="form.bankCode"></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="电子邮箱：" prop="email">
              <el-input v-model="form.email"></el-input> </el-form-item
          ></el-col>
        </el-row>
      </div>
      <div class="one">
        <div class="title">邮寄信息</div>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="收件人姓名：" prop="recipient">
              <el-input v-model="form.recipient"></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="收件地址：" prop="recipientAddress">
              <el-input
                v-model="form.recipientAddress"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="收件人手机：" prop="recipientPhone">
              <el-input v-model="form.recipientPhone"></el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item label="邮编：" prop="recipientZipCode">
              <el-input
                v-model="form.recipientZipCode"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-form-item style="margin-left: 36%; margin-top: 20px">
          <el-button type="primary" @click="onSubmit('form')">保存</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">
import {
  saveCompanyInvoiceInfo,
  getInvoiceCompanyInfo,
  getComInfo,
} from "../apis/project/index";
export default {
  data() {
    const phoneRules = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else {
        const reg =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    const emailRules = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入电子邮箱"));
      } else {
        const reg =
          /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入有效的电子邮箱"));
        }
      }
    };
    const bankNameRule = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入开户行"));
      } else {
        const reg = /^[\u4e00-\u9fa5\（\）\(\)]*$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("开户行只能为汉字或汉字+（）"));
        }
      }
    };
    const bankCodeRule = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入开户行基本账号"));
      } else {
        const reg = /^[0-9]*$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("开户行基本账号必须为数字"));
        }
      }
    };
    const recipientRule = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入收件人姓名"));
      } else {
        const reg = /^[\u4e00-\u9fa5]*$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("收件人姓名必须为2~4位汉字"));
        }
      }
    };
    return {
      comInfo: {},
      form: {
        userName: "",
        bankName: "",
        recipientAddress: "",
        recipientPhone: "",
        recipientZipCode: "",
        email: "",
        recipient: "",
        invoicePhone: "",
        bankCode: "",
      },
      rules: {
        invoicePhone: [
          { required: true, message: "请输入固定电话", trigger: "blur" },
        ],
        bankName: [
          { required: true, validator: bankNameRule, trigger: "blur" },
        ],
        registeredAddress: [
          { required: true, message: "请输入企业地址", trigger: "blur" },
        ],
        bankCode: [
          { required: true, validator: bankCodeRule, trigger: "blur" },
        ],
        information: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
        ],
        email: [{ required: true,  validator: emailRules, trigger: "blur" }],
        recipient: [
          { required: true, validator: recipientRule, trigger: "blur" },
          { min: 2, max: 4, message: "收件人姓名必须为2~4位汉字" },
        ],
        recipientPhone: [
          { required: true, validator: phoneRules, trigger: "blur" },
        ],
        recipientAddress: [
          { required: true, message: "请输入收件地址", trigger: "blur" },
        ],
        recipientZipCode: [
          { required: true, message: "请输入收件邮编", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getInvoiceCompanyInfo();
    this.getComInfo();
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          saveCompanyInvoiceInfo(this.form).then((res) => {
            if (res.data.status == 1) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.$router.push("/invoice");
            } else {
              this.$message({
                message: res.data.statusInfo,
                type: "error",
              });
            }
          });
        }
      });
    },
    getInvoiceCompanyInfo() {
      getInvoiceCompanyInfo({
        userId: Number(window.sessionStorage.getItem("userId")),
      }).then((res) => {
        //  this.form = res.data.data;
        this.form.userName = window.sessionStorage.getItem("username");
        if (res.data.data) {
          for (let key in this.form) {
            this.form[key] = res.data.data[key];
          }
          this.form.email = res.data.data.invoiceEmail;
          this.form.recipient = res.data.data.recipientName;
          this.form.recipientZipCode = res.data.data.recipientPostCode;
          this.form.userName = window.sessionStorage.getItem("username");
        }
        console.log(this.form);
      });
    },
    getComInfo() {
      getComInfo().then((res) => {
        if (res.data.status === 1) {
          this.comInfo = res.data.data;
        } else {
          this.$confirm(
            "当前登录账户未进行企业认证，请先进行企业信息验证,点击确定后跳转企业认证页面",
            "提示",
            {
              confirmButtonText: "确定",
              type: "warning",
              showCancelButton: false,
              closeOnPressEscape: false,
              showClose: false,
              closeOnClickModal:false
            }
          ).then(() => {
            this.$router.push("/personalInfo");
          });
        }
      });
    },
  },
  components: {},
};
</script>

<style lang="less" scoped>
.page {
  height: 100%;
  .one {
    padding: 30px;
    background-color: #ffffff;
    margin-bottom: 20px;
    .title {
      border-left: 5px #017eff solid;
      padding-left: 10px;
    }
    .yi {
      display: flex;
      color: #ffffff;
      .left {
        padding: 13px 20px;
        background-color: #017eff;
        flex: 1;
        display: flex;
        align-items: center;
        .text {
          width: 80%;
          p:first-child {
            margin-bottom: 10px;
          }
          p {
            padding: 3px 0;
          }
        }
        .image {
          width: 20%;
          display: flex;
          justify-content: flex-end;
          img {
            width: 80%;
          }
        }
      }
      .right {
        flex: 1;
        margin-left: 40px;
        // margin-left: 20px;
      }
    }
  }
}
::v-deep .el-form-item__label {
  font-weight: bold;
}
</style>
